import Design from "./Design";
import Info from "./Info";
import Publish from "./Publish";

const steps = { design: Design, info: Info, publish: Publish };

export default steps;
